<template>
    <div class="Overallarchivereport" @scroll="handleScroll">
        <p class="titleName">
            {{ProfilData.userSummary.realName}}的整体档案报告
            <div class="export">
                <el-button type="primary"><i class="el-icon-upload2"></i>导出报告</el-button>
            </div>
        </p>

        <div class="item">
            <p class="title"><span>1</span>基本信息</p>
            <div class="userinfo">
                <i style="background: #D6EFFF;height: 18px;display: block;"></i>
                <div class="info">
                    <div class="items">姓名：{{ProfilData.userSummary.realName}}</div>
                    <div class="items">职业：{{ProfilData.userSummary.profName}}</div>
                    <div class="items">性别：{{ProfilData.userSummary.sex}} </div>
                    <div class="items">年龄：{{ProfilData.userSummary.ages}}</div>
                </div>
                <div class="info">
                    <div class="items">学历：{{ProfilData.userSummary.degree}}</div>
                    <div class="items">婚姻：{{ProfilData.userSummary.marriageState}}</div>
                    <div class="items">民族：{{ProfilData.userSummary.nation}} </div>
                    <div class="items">籍贯：{{ProfilData.userSummary.nativeplace   }}</div>
                </div>
                <div class="info">
                    <div class="items">是否为独生子女：{{ ProfilData.userSummary.gkd_OnlySon==0?'否':'是' }}</div>
                    <div class="items">家庭所在地类型：{{ProfilData.userSummary.accountType==0?'城市':ProfilData.userSummary.accountType==1?'农村':'乡镇'}}</div>
                    <div class="items">父亲文化程度：{{ProfilData.userSummary.gkd_FatherDegree}} </div>
                    <div class="items">母亲文化程度：{{ProfilData.userSummary.gkd_MatherDegree}}</div>
                </div>
                <div class="info">
                    <div class="items">目前家庭情况：{{ProfilData.userSummary.gkd_FamilyStatus}}</div>
                    <div class="items">家庭成员有无精神病史：{{ ProfilData.userSummary.gkd_MentalHistory==0?'否':'是'}}</div>
                </div>
            </div>
        </div>

        <div class="item">
            <p class="title"><span>2</span>心理画像</p>
            <div class="left">
                <div class="Mental">
                    <p class="mintitle"><i><img src="@/assets/Userportrait/img13.png" alt=""></i>心理健康</p>
                    <div class="MentalHealth">
                        <div v-for="item in ProfilData.userSummary.psyProfilHealth">
                            <span>{{item.factorName}}：</span>
                            <label :style="{'color':item.colorName}">{{item.resultGrade}}<i :style="{'background':item.colorName,'opacity':0.1}"></i></label>
                        </div>
                    </div>
                </div>

                <div class="Preferences">
                    <p class="mintitle"><i><img src="@/assets/Userportrait/img9.png" alt=""></i>偏好特征</p>
                    <div id="myChart" ref="myChart" style="width:390px;height:350px;"></div>
                </div>
            </div>

            <div class="right">
                <div class="middle">
                    <div class="portrait_img">
                        <img v-if="ProfilData.userSummary.sex=='女'" src="@/assets/Userportrait/portrait02.png">
                        <img v-else src="@/assets/Userportrait/portrait01.png">
                    </div>
                    <div class="feature">
                        <div class="list" v-for="item in ProfilData.userSummary.psyProfilCharacter">{{item.factorName}}</div>
                    </div>
                </div>
            </div>

        </div>

        <div class="item second">
            <div class="items">
                <div class="subtitle">
                    <i><img src="@/assets/Userportrait/Userportrait_icon08.png"></i>心理能力
                </div>
                <div class="secondleft">
                    <div class="aa">
                        <p class="aa_subtitle">
                            <span><i><img src="@/assets/Userportrait/Userportrait_icon10.png"></i>智商水平</span>
                            <label>125分</label>
                        </p>
                        <div class="content">
                            太厉害了，你的智商超过95%的同龄人。
                        </div>
                    </div>
                    <div class="aa bb">
                        <p class="aa_subtitle">
                            <span><i><img src="@/assets/Userportrait/Userportrait_icon11.png"></i>情商水平</span>
                            <label>125分</label>
                        </p>
                        <div class="content">
                            EQ水平较高，情绪稳定，乐观自信，客观冷静，人际交往、处理问题及社会适应能力较强，是一种积极健康的心理状态
                        </div>
                    </div>
                </div>
                <div ref="Psychologicalability" class="Psychologicalability"></div>

            </div>
            <div class="items">
                <div class="subtitle">
                    <i><img src="@/assets/Userportrait/Userportrait_icon09.png"></i>数据总览
                </div>
                <div id="datascreen" ref="datascreen" style="width:100%;height:415px;"></div>
            </div>
        </div>

        <div class="item" v-for="item in yearMonthRecords">
            <p class="title">
                <span>{{item.yearMonth.split('-')[1]}}月</span>{{item.yearMonth}}
                <label @click="testResults=ProfilData.testResults">展开所有记录<i class="el-icon-caret-bottom"></i></label>
            </p>
            <div class="record">
                <el-table :data="testResults" style="width: 100%">
                    <el-table-column type="paperName" label="类目"></el-table-column>
                    <el-table-column prop="recordTime" label="时间"></el-table-column>
                    <el-table-column prop="userID" label="账号"></el-table-column>
                    <el-table-column prop="realName" label="姓名"></el-table-column>
                    <el-table-column prop="age" label="年龄"></el-table-column>
                    <el-table-column prop="sex" label="性别"></el-table-column>
                    <el-table-column prop="sourceFlg" label="服务内容"></el-table-column>
                    <el-table-column prop="sourceFlg" label="危机等级"></el-table-column>
                    <el-table-column label="操作">
                        <template v-slot="scoped">
                            <el-button type="text">报告</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <i class="seticon el-icon-s-operation" @click="contentset=!contentset"></i>


        <!-- 内容设置 -->
        <div class="contentset" v-if="contentset">
            <b class="title">内容设置</b>
            <div class="contentsetitem">
                <label>时间范围</label>
                <el-date-picker
                class="widthinput"
                v-model="timeRange"
                type="daterange"
                range-separator="至"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                clearable
                start-placeholder="开始日期"
                end-placeholder="结束日期">
                </el-date-picker>
            </div>
            <div class="contentsetitem">
                <label>内容分类</label>
                <el-select class="widthinput" v-model="params.contentType" clearable placeholder="请选择">
                    <el-option v-for="item in dictionaryLevelPage" :key="item.dicKey" :label="item.eDicValue" :value="item.dicKey"></el-option>
                </el-select>
            </div>
            <div class="contentsetitem">
                <label>危机等级</label>
                <el-select class="widthinput" v-model="params.level" clearable placeholder="请选择">
                    <el-option v-for="(item,index) in level" :key="index" :label="item" :value="item"></el-option>
                </el-select>
            </div>
            <div class="contentsetitem">
                <label>是否自测</label>
                <el-select class="widthinput" v-model="params.isSelfTest" clearable placeholder="请选择">
                    <el-option label="否" :value="0"></el-option>
                    <el-option label="是" :value="1"></el-option>
                </el-select>
            </div>
            <div class="contentsetitem" style="text-align: center;">
                <el-button @click="reset">重置</el-button>
                <el-button type="primary" @click="init">搜索</el-button>
            </div>
        </div>
        

    </div>
</template>
<script>
    export default{
        data() {
            return {
                // userID:this.$route.query.userID,
                contentset:false,
                userID:'admin',
                level:['正常','轻度','中度','较重', '重度'],
                dropKeyContent:[],
                readQnty:[],
                testResults:[],
                yearMonthRecords:[],
                timeRange:[],
                ProfilData:{
                    userSummary:{}
                },
                dictionaryLevelPage:[],
                params:{
                    userID:'',
                    startTime:'',
                    endTime:'',
                    contentType:'',
                    level:'',
                    isSelfTest:'',//0否 1是
                }
            }
        },
        watch: {
            timeRange(newval,oldval){
                if(newval==null){
                    this.params.startTime='';
                    this.params.endTime='';
                }
                this.params.startTime=newval[0];
                this.params.endTime=newval[1];
            }
        },
        created(){
            this.timeRange=this.Global.querycensus(6);
            this.params.userID=this.userID;
            this.getdropkeycontent()
        },
        mounted() {
            this.params.startTime=this.timeRange[0];
            this.params.endTime=this.timeRange[1];
            this.init();
        },
        methods: {
            // 获取内容分类
            getdropkeycontent(){
                this.$Http_Post('/User/dictionaryLevelPage',{DicTypCode:57,PageIndex:1,PageSize: 10}).then(res=>{
                    if(res.Code==0 || res.Code==200){
                        this.dictionaryLevelPage=res.Data;
                    }
                })
            },

            reset(){
                this.params=this.$options.data().params;
                this.params.startTime=this.timeRange[0];
                this.params.endTime=this.timeRange[1];
                this.params.userID=this.userID;
                this.init();
            },
            init(){
                this.$Http_Post('/userprofile/getuserprofile',this.params).then(res=>{
                    if(res.Code==0 || res.Code==200){
                        this.ProfilData=res.Data;
                        this.yearMonthRecords=res.Data.yearMonthRecords;
                        if(res.Data.userSummary.psyProfilPreference){
                            let psyProfilPreference=res.Data.userSummary.psyProfilPreference;
                            for(var i=0;i<psyProfilPreference.length;i++){
                                this.dropKeyContent.push(psyProfilPreference[i].dropKeyContent);
                                let str={value: psyProfilPreference[i].readQnty,itemStyle: {color:this.color[i]}}
                                this.readQnty.push(str);
                            }
                        }
                        this.$nextTick(()=>{
                            this.initChart();
                            this.Psychologicalabilityfun(res.Data);
                            this.datascreenfun();
                        });
                        
                    }else{
                        this.$message.error(res.Message);
                    }
                })
            },

  
             initChart(){
                let myChart = this.$echarts.init(this.$refs.myChart);
                var option={
                    grid: { 
                        left: 70,
                    },
                    tooltip: {
                        trigger: 'axis',
                    },
                    xAxis: {},
                    yAxis: {
                        type: 'category',
                        data:this.dropKeyContent,
                    },
                    series: [{
                        type: 'bar',
                        data:this.readQnty,
                    },
                    ]
                };
                myChart.setOption(option);
                window.addEventListener("resize", function () {
                    myChart.resize();
                });
            },

            // 心理能力
            Psychologicalabilityfun(){
                let Psychologicalability = this.$echarts.init(this.$refs.Psychologicalability);
                var option = {
                    
                    tooltip: {trigger: 'axis'},
                    legend:{},
                    radar: {
                        // shape: 'circle',
                        indicator: [
                            { name: '语言能力', max: 6500,color: '#1F78FF' },
                            { name: '逻辑数学', max: 16000,color: '#FF5733'  },
                            { name: '空间视觉', max: 30000,color: '#00C2AB' },
                            { name: '运动能力', max: 38000 ,color: '#ED8E00' },
                            { name: '音乐', max: 52000,color: '#B144CF'},
                            { name: '自然环境', max: 30000,color: '#32B332'},
                            { name: '人际关系', max: 30000,color: '#F74DA5'},
                            { name: '自我内省', max: 30000,color: '#25AEDB'}
                        ],
                        splitArea: {
                            areaStyle: {
                            color: ['#F2F7FF'],
                            }
                        },
                    },
                    series: [
                        {
                        type: 'radar',
                        lineStyle: {  
                            color: '#4A92FF'
                        }, 
                        tooltip: {trigger: 'item'},
                        data: [
                            {
                                value: [5000, 14000, 28000, 26000, 42000, 21000],
                                areaStyle: {
                                    color: new this.$echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                                    {
                                        color: 'rgba(60, 129, 232, 0.2)',
                                        offset: 1
                                    }
                                    ])
                                }
                            }
                        ]
                        }
                    ]
                };
                Psychologicalability.setOption(option);
                window.addEventListener("resize", function () {
                    Psychologicalability.resize();
                });
            },

            // 数据总览
            datascreenfun(){
                let datascreen = this.$echarts.init(this.$refs.datascreen);
                var option={
                    tooltip: {trigger: 'item'},
                    legend: { 
                        top: '5%',
                        data:['心理测评', '心理咨询', '心理访谈', '认知训练', '心理活动','教育培训'],
                    },
                    color: ['#F2BA00', '#17C480', '#2B8DFC','#7948EA','#D849EB','#D43030'],
                    series: [
                        {
                            name: '',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            label: {
                            formatter: ' {b|{b}：}| {d}%  ',
                            backgroundColor: '#F6F8FC',
                            borderWidth: 1,
                            borderRadius: 4,
                            rich: {
                                b: {
                                    color: '#4C5058',
                                    fontSize: 14,
                                    fontWeight: 'bold',
                                    lineHeight: 33
                                },
                            }
                        },
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 3
                        },
                        data: [
                            { value: 1048, name: '心理测评' },
                            { value: 735, name: '心理咨询' },
                            { value: 580, name: '心理访谈' },
                            { value: 484, name: '认知训练' },
                            { value: 300, name: '心理活动' },
                            { value: 300, name: '教育培训' },
                        ]
                        }
                    ]
                };
                datascreen.setOption(option);
                window.addEventListener("resize", function () {
                    datascreen.resize();
                });
            },
            handleScroll(event){
                if (event.target.scrollTop > 0 && this.contentset) {
                    this.contentset=false;
                }
            }
        },
    }
</script>
<style scoped>
.Overallarchivereport{background: #fff;padding: 0 40px 80px;min-width:1290px;height: calc(100vh - 80px);overflow: auto;}
.Overallarchivereport .item .right{float: left;margin: 120px 0 0 100px;}
.Overallarchivereport .item .right .middle{width: 624px;height: 624px;display: inline-block;position: relative;}
.Overallarchivereport .item .right .middle::before{content: '';position: absolute;background: url('../../assets/Userportrait/Userportrait_icon12.png') 100%; width: 432px;height: 295px;background-size: 100%;bottom: -60px;left: 50%;margin-left: -220px;}
.Overallarchivereport .item .right .middle .portrait_img{width: 260px;margin: -120px auto 0;}
.Overallarchivereport .item .right .middle .feature{position: absolute;width: 100%;height: 100%;top: 0;left: 0;z-index: 2;}
.Overallarchivereport .item .right .middle .feature .list{position: absolute;border-radius: 50%;overflow: hidden;text-align: center;color: #fff;}
.Overallarchivereport .item .right .middle .feature .list:nth-child(1){top:-50px;left:50px;width: 115px;height: 115px;font-size: 45px;padding: 30px;background: #ED8E5F;}
.Overallarchivereport .item .right .middle .feature .list:nth-child(2){top:0;right: 90px;font-size: 24px;padding:20px;width: 68px;height: 68px;background: #BB36E0;}
.Overallarchivereport .item .right .middle .feature .list:nth-child(3){top:120px;left:-30px;font-size: 20px;padding: 15px 20px;width: 40px;height:50px;background: #41CCAE;}
.Overallarchivereport .item .right .middle .feature .list:nth-child(4){top: 100px;right:10px;font-size: 20px;padding:10px 15px;width:40px;height: 50px;background: #1F93FF;}
.Overallarchivereport .item .right .middle .feature .list:nth-child(5){top:170px;left:80px;font-size: 20px;padding: 15px 20px;width: 40px;height:50px;background: #E8B235;}
.Overallarchivereport .item .right .middle .feature .list:nth-child(6){top:190px;right:-80px;font-size: 20px;padding:15px;width: 48px;height: 48px;background: #E34DC2;}
.Overallarchivereport .item .right .middle .feature .list:nth-child(7){top:250px;left:-50px;font-size:16px;padding:10px 15px;width:34px;height:44px;background: #3D8DD9;}
.Overallarchivereport .item .right .middle .feature .list:nth-child(8){top:230px;right:50px;font-size:36px;padding:20px 30px;width: 74px;height:94px;background: #32B858;}
.Overallarchivereport .item .right .middle .feature .list:nth-child(9){top:280px;left:60px;font-size:32px;padding:20px;width:80px;height:80px;background: #7D69D6;}
.Overallarchivereport .item .right .middle .feature .list:nth-child(10){top:340px;right:-50px;font-size:20px;padding:15px;width: 48px;height:48px;background: #F74859;}
.Overallarchivereport .item .right .middle .feature .list:nth-child(11){top:400px;left:-50px;font-size:16px;padding:10px 15px;width:34px;height:44px;background: #F74859;}
.Overallarchivereport .item .right .middle .feature .list:nth-child(12){top:400px;right:80px;font-size:24px;padding:15px 20px;width: 55px;height:65px;background: #435FDE;}
.Overallarchivereport .item .right .middle .feature .list:nth-child(13){top:500px;left:50px;font-size:16px;padding:15px;width:40px;height:40px;background: #E34DC2;}
.Overallarchivereport .item .right .middle .feature .list:nth-child(14){top:500px;right:30px;font-size:16px;padding:15px;width:40px;height:40px;background: #E8B235;}
.Overallarchivereport .titleName{font-size: 40px;text-align: center;padding: 50px 0 0;position: relative;}
.Overallarchivereport .export{position: absolute;right:30px;top:60px;z-index: 2;}
.Overallarchivereport .item{margin-top: 40px;}
.Overallarchivereport .item::after{content: '';clear: both;display:block;height: 0;}
.Overallarchivereport .item .title{font-size: 20px;background: linear-gradient(90deg, rgba(53, 108, 220, 1) 0%, rgba(131, 212, 184, 1) 49.8%, rgba(215, 247, 245, 1) 99.31%);line-height: 45px;height: 45px;color: #fff;position: relative;text-indent: 60px;width: calc(100% - 10px);margin-left: 10px;}
.Overallarchivereport .item .title span{font-size: 20px;width: 80px;height: 55px;line-height: 55px;display: inline-block;text-align: center;position: absolute;z-index: 2;top: -10px;left: 0;text-indent: -30px;}
.Overallarchivereport .item .title span::before{content: '';width:80px;height:55px;display: inline-block;position: absolute;top: 0;left:-10px;z-index: -1;background: url('../../assets/img/report_bg.png') no-repeat 100%;}
.Overallarchivereport .item .title label{float: right;color:#508FFE;text-indent: 0;padding-right: 20px;cursor: pointer;}
.Overallarchivereport .item .userinfo .info{display: flex;padding: 8px 0;}
.Overallarchivereport .item .userinfo .info .items{width: 25%;text-indent: 30px;}
.Overallarchivereport .item .userinfo .info:nth-child(2n+1){background: #D6EFFF;}
.Overallarchivereport .item .record{padding: 20px;background: #F7FCFF;}
.Overallarchivereport .item .record::before{display: none;}
.Overallarchivereport .item .left{width: 390px;margin:30px 0 0 0;float: left;}
.Overallarchivereport .item .left .Mental{background: #F2F7FF;box-shadow: 0px 5px 10px  #9BAFCC;border-radius: 16px;}
.Overallarchivereport .item .left .Mental .mintitle{border-radius: 16px 16px 0 0;background: linear-gradient(180deg, #5ED1B4 0%, #39C467 100%);padding: 18px;color: #fff;font-weight: bold;font-size: 18px;}
.Overallarchivereport .item .left .Mental .mintitle i{width:22px;display: inline-block;margin-right: 10px;position: relative;top:5px;}
.Overallarchivereport .item .left .Mental .MentalHealth{font-size: 14px;display: flex;flex-wrap: wrap;padding:0 15px;min-height: 200px;}
.Overallarchivereport .item .left .Mental .MentalHealth div{font-size: 14px;display: block;width: 50%;padding: 10px 0;}
.Overallarchivereport .item .left .Mental .MentalHealth div span{display: inline-block;width: 100px;text-align: right;}
.Overallarchivereport .item .left .Mental .MentalHealth div label{border-radius: 50px;width: 72px;line-height: 22px;text-align: center;display: inline-block;position: relative;}
.Overallarchivereport .item .left .Mental .MentalHealth div label i{position: absolute;top: 0;left: 0;width: 100%;height: 100%;border-radius: 200px;}
.Overallarchivereport .item .left .Preferences{background: #F2F7FF;box-shadow: 0px 5px 10px  #9BAFCC;border-radius: 16px;margin-top:40px;}
.Overallarchivereport .item .left .Preferences .mintitle{border-radius: 16px 16px 0 0;background:linear-gradient(180deg, #FF8C8C 0%, #F56464 100%);padding: 18px;color: #fff;font-weight: bold;font-size: 18px;}
.item .left .Preferences .mintitle i{width:22px;display: inline-block;margin-right: 10px;position: relative;top: 5px;}
img{width: 100%;display: block;}

.Overallarchivereport .second{display: flex;justify-content: space-between;}
.Overallarchivereport .second .items{flex: 1;background: #F2F7FF;margin:0 10px;border-radius: 16px;overflow: hidden;height: 475px;}
.Overallarchivereport .second .items:first-child{margin-right: 10px;}
.Overallarchivereport .second .items:last-child{margin-left: 10px;}
.Overallarchivereport .second .items .subtitle{display: flex;align-items: center;padding: 14px 20px;color: #fff;font-size:18px;font-weight: bolder;}
.Overallarchivereport .second .items:first-child .subtitle{background:linear-gradient(180deg, rgba(99, 161, 247, 1) 0%, rgba(73, 124, 242, 1) 100%);display: flex;align-items: center;padding: 14px 20px;color: #fff;font-size:18px;font-weight: bolder;}
.Overallarchivereport .second .items .subtitle i{width: 16px;height:16px;background: #fff;border-radius: 50%;display: inline-block;padding:6px;margin-right: 10px;}
.Overallarchivereport .second .items:last-child .subtitle{background: linear-gradient(180deg, rgba(55, 200, 240, 1) 0%, rgba(0, 157, 209, 1) 100%);}
.Overallarchivereport .second .items .secondleft {width: 260px;margin: 20px 20px 0;float: left;}
.Overallarchivereport .second .items .secondleft .aa{background: #EEE1FA;border-radius: 8px;overflow: hidden;height:180px;}
.Overallarchivereport .second .items .secondleft .aa .aa_subtitle{color: #fff;font-size: 18px;line-height: 47px;background: #9A53DB;padding:0 20px;display: flex;align-items: center;justify-content: space-between;}
.Overallarchivereport .second .items .secondleft .aa .aa_subtitle span{display: flex;align-items: center;}
.Overallarchivereport .second .items .secondleft .aa .aa_subtitle i{width: 22px;display: inline-block;margin-right:10px;}
.Overallarchivereport .second .items .secondleft .aa .aa_subtitle label{font-size: 24px;float: right;}
.Overallarchivereport .second .items .secondleft .aa .content{font-size: 14px;padding: 10px;}
.Overallarchivereport .second .items .secondleft .bb{background: #CBEEF5;margin-top: 20px;}
.Overallarchivereport .second .items .secondleft .bb .aa_subtitle{background: #2FBAD6;}
.Overallarchivereport .second .items .Psychologicalability{float: right;width:50%;height:300px;margin:60px 0;}
.Overallarchivereport .seticon{position: fixed;top: 100px;right:30px;z-index: 9;font-size: 30px;cursor: pointer;color: gray;}
.Overallarchivereport .contentset{position: fixed;top: 130px;right: 80px;width: 350px;border-radius: 8px;background: #fff;z-index: 9;border: 1px solid #DDDDDD;padding: 20px 0;}
.Overallarchivereport .contentset .widthinput{width: 240px;}
.Overallarchivereport .contentset .title{font-size: 16px;text-align: center;display: block;}
.Overallarchivereport .contentset .contentsetitem{padding: 8px 20px;}
.Overallarchivereport .contentset .contentsetitem label{margin-right: 10px;}

/*滚动条样式*/
::-webkit-scrollbar {/*滚动条整体样式*/
            width: 4px;     /*高宽分别对应横竖滚动条的尺寸*/
            height: 4px;
        }
::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
            border-radius: 5px;
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            background: rgba(0,0,0,0.2);
        }
::-webkit-scrollbar-track {/*滚动条里面轨道*/
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            border-radius: 0;
            background: rgba(0,0,0,0.1);
        }
</style>